import React from "react";
import PropTypes from "prop-types";
import ItemComponent from "./ItemComponent";
import { Box } from "@mui/material";

const ListComponent = ({ logs }) => (
  <Box display="flex" flexDirection="column" my={2} gap={2}>
    {logs.map(n => {
      return <ItemComponent key={n.id} item={n} />;
    })}
  </Box>
);

ListComponent.propTypes = {
  logs: PropTypes.array.isRequired
};

export default ListComponent;
